import React from 'react';
import { connect } from 'react-redux';
import { addPhone } from 'legacy/actions/userActions';
import { addOrgPhone } from 'legacy/actions/orgActions';
import ModalBase from '../ModalBase/ModalBase';
import EnterPhoneForm from './components/EnterPhoneForm';
import { BaseModalProps } from '../ModalBase/ModalBase';
import { PhoneUser, LoadingState, ErrorState } from '../types';

interface AddPhoneProps {
  loading: LoadingState;
  errors: ErrorState;
  user: PhoneUser;
  addPhone: (number: string) => void;
  addOrgPhone: (orgId: string, number: string) => void;
  orgId?: string;
  baseModalProps: BaseModalProps;
  onSuccess?: () => void;
  overrideBaseModalProps?: any;
}

function AddPhone({
  loading,
  errors,
  user,
  addPhone,
  addOrgPhone,
  orgId,
  baseModalProps,
  onSuccess,
  overrideBaseModalProps
}: AddPhoneProps) {
  const handleSubmit = (number: string) => {
    if (orgId) {
      addOrgPhone(orgId, number);
    } else {
      addPhone(number);
    }
  };

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      contentClassName="basic"
      hideBackButton
      {...overrideBaseModalProps}
    >
      <EnterPhoneForm
        user={user}
        errors={errors}
        loading={loading}
        onSubmitNumber={handleSubmit}
        submitActionType={orgId ? 'ADD_ORG_PHONE' : 'ADD_PHONE'}
        onSuccess={onSuccess}
      />
    </ModalBase>
  );
}

const actions = { addPhone, addOrgPhone };

const mapStateToProps = (state: any, { orgId }: { orgId?: string }) => {
  const selector = orgId ? 'orgs' : 'user';
  return {
    user: orgId ? state.orgs.orgs[orgId] : state.user.user,
    errors: state[selector].errors,
    loading: state[selector].loading
  };
};

export default connect(mapStateToProps, actions)(AddPhone);
